import { addDays, addMinutes, min } from 'date-fns';
import { type Program, type ProgramPostContentObjectList, getMinContentDate } from 'models';
import { useMemo } from 'react';
import { generateAttachmentsInputInitialValue, getDatePickerDateType } from 'ui';
import type { PostFormValues } from '../PostForm';

type P = {
  postContentObject?: ProgramPostContentObjectList;
  preSelectedProgramTopicId?: string;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useGetPostInitialValues = ({
  postContentObject,
  preSelectedProgramTopicId,
  program,
}: P): Partial<PostFormValues> =>
  useMemo(() => {
    const publishAt =
      postContentObject?.publishAt ??
      min([addMinutes(getMinContentDate({ startTime: program.startTime }), 10), program.endTime]);
    const todoDueDate = postContentObject?.post.todoDueDate ?? min([addDays(publishAt, 1), program.endTime]);

    return {
      attachments: generateAttachmentsInputInitialValue(postContentObject?.attachments),
      htmlContent: postContentObject?.post.htmlContent,
      programTopicId: postContentObject?.programsTopic.id ?? preSelectedProgramTopicId,
      publishAt: getDatePickerDateType(publishAt),
      textContent: postContentObject?.post.textContent,
      title: postContentObject?.post.title,
      todoDueDate: getDatePickerDateType(todoDueDate),
    };
  }, [postContentObject, preSelectedProgramTopicId, program]);
